export const CLIENT_SIGNING_FEATURE = 'use_client_signing'
export const CLIENT_SIGNING_DISABLED_MESSAGE = 'Client signing is not enabled for this user'

type UserFeature = string | { name?: string | null }

export function hasClientSigningFeature(features: UserFeature[] | null | undefined): boolean {
    return !!features?.some(feature =>
        typeof feature === 'string'
            ? feature === CLIENT_SIGNING_FEATURE
            : feature?.name === CLIENT_SIGNING_FEATURE,
    )
}

// A promoted user whose wallet Treechat still holds (gon.localSigningShareRecovery): a
// browser without the local key sends the request with no device id and Treechat signs it
// (LocalSigningShadow::Promotion.device_signing?), instead of refusing the action.
export function treechatSignsWithoutLocalKey(): boolean {
    return window.gon?.localSigningShareRecovery === true
}

export function currentUserUsesClientSigning(): boolean {
    return hasClientSigningFeature(window.gon?.currentUser?.features)
}

export function requireClientSigningFeature(): void {
    if (!currentUserUsesClientSigning()) {
        throw new Error(CLIENT_SIGNING_DISABLED_MESSAGE)
    }
}

// Dispatched when a wallet first lands on this device without a page load (a new
// browser-wallet signup), so the signing listener (useUserChannel) starts for it.
export const CLIENT_SIGNING_READY_EVENT = 'treechat:client-signing-ready'
